<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-col cols="8" style="text-align: left">
          <v-btn
            text
            x-small
            @click="
              status = '';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="info"
                :content="totalTasks.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == ''" style="color: #7cb342">All</b>
                <b v-else>All</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'New';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="orange"
                :content="newTasks.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'New'" style="color: #7cb342">New</b>
                <b v-else>New</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Assigned';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="orange"
                :content="assignedTasks.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Assigned'" style="color: #7cb342"
                  >Assigned</b
                >
                <b v-else>Assigned</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Processing';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="orange"
                :content="processingTasks.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Processing'" style="color: #7cb342"
                  >Processing</b
                >
                <b v-else>Processing</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Need Review';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="#00ACC1"
                :content="needReviewTasks.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Need Review'" style="color: #7cb342"
                  >Need Review</b
                >
                <b v-else>Need Review</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Completed';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="success"
                :content="completedTasks.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Completed'" style="color: #7cb342"
                  >Completed</b
                >
                <b v-else>Completed</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Canceled';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="red"
                :content="canceledTasks.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Canceled'" style="color: #7cb342"
                  >Canceled</b
                >
                <b v-else>Canceled</b>
              </v-badge>
            </v-tab>
          </v-btn>
        </v-col>

        <v-col cols="4" style="text-align: right">
          <!-- <v-btn
            color="success"
            dark
            @click="dialogNewTask = !dialogNewTask"
          >New Task</v-btn> -->
          <v-btn small @click.stop="drawer = !drawer" outlined color="indigo"
            >Filter Data</v-btn
          >
          &nbsp;
          <template>
            <v-btn
              small
              color="orange"
              dark
              @click="clear"
              v-if="selected.length > 0"
              >Clear Task(s) ({{ selected.length }})</v-btn
            >
            <v-btn small color="orange" @click="clear" v-else disabled
              >Clear Task(s) ({{ selected.length }})</v-btn
            >
            &nbsp;
            <v-btn
              small
              color="primary"
              @click="dialogImport = !dialogImport"
              v-if="roles.import_task"
              >Import</v-btn
            >
            <v-btn small color="primary" v-else disabled>Import</v-btn>
            &nbsp;
            <v-btn
              small
              color="purple"
              dark
              @click="dialogExport = !dialogExport"
              v-if="roles.export_task"
              >Export</v-btn
            >
            <v-btn small color="purple" v-else disabled>Export</v-btn>
          </template>
          &nbsp;
          <template>
            <v-btn
              small
              color="primary"
              dark
              @click="dialogAssign = !dialogAssign"
              v-if="selected.length > 0 && roles.assign_task"
              >Assign Task ({{ selected.length }})</v-btn
            >
            <v-btn small color="primary" disabled v-else>Asign Task</v-btn>
          </template>
        </v-col>
      </v-row>
    </v-col>

    <v-alert
      v-model="alert"
      close-text="Close Alert"
      dense
      text
      type="success"
      dismissible
      style="text-align: left"
    >
      {{ informText }}
    </v-alert>

    <v-col cols="12">
      <v-col cols="12" class="border rounded">
        <v-row>
          <span
            v-for="(i, index) in listDesigner"
            :key="index"
            style="margin-left: 35px; margin-top: 10px"
          >
            <v-badge
              color="light-blue darken-4"
              :content="
                i.delayTaskCount.toString() + '/' + i.taskCount.toString()
              "
              style="font-size: 13px"
            >
              <b>{{ i.username }}</b>
            </v-badge>
          </span>
        </v-row>
      </v-col>
    </v-col>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="tasks"
      :options.sync="pagination"
      :server-items-length="matchingTasks"
      item-key="_id"
      show-select
      class="elevation-1"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': [10, 20, 50, 100, 200, 500, 1000],
      }"
    >
      <template v-slot:item.thumbnail="{ item }">
        <img :src="item.thumbnail" style="width: 100px" />
      </template>
      <template v-slot:item.related_orders="{ item }">
        <template v-if="!item.urgent && item.priority == 0">
          <div v-for="(i, index) in item.listOrderNumber" :key="index">
            {{ i }}
          </div>
        </template>
        <template v-else>
          <div v-for="i in item.listOrderNumber" :key="i" style="color: red">
            {{ i }}
          </div>
        </template>
      </template>
      <template v-slot:item.product_info="{ item }">
        <td style="font-size: 12px" v-if="!item.urgent && item.priority == 0">
          <div><b>TaskID:</b> {{ item._id }}</div>
          <div>
            <b>Product ID:</b>
            <template
              v-if="
                item.product_design_type === 'choose_options' ||
                item.product_design_type === 'upload_photo'
              "
            >
              <a
                :href="
                  '/personalize-products?searchBy=product_id&searchWord=' +
                  item.product_id
                "
                target="_blank"
                style="text-decoration: none"
              >
                {{ item.product_id }}
              </a>
            </template>
            <template
              v-else-if="
                item.product_design_type === 'Crawl Design' ||
                item.product_design_type === 'Personalize Design'
              "
            >
              <a
                :href="
                  '/products?searchBy=product_id&searchWord=' + item.product_id
                "
                target="_blank"
                style="text-decoration: none"
              >
                {{ item.product_id }}
              </a>
            </template>
            <template v-else-if="item.product_design_type === 'Normal Design'">
              <a
                :href="
                  '/normal-products?searchBy=product_id&searchWord=' +
                  item.product_id
                "
                target="_blank"
                style="text-decoration: none"
              >
                {{ item.product_id }}
              </a>
            </template>
          </div>
          <div><b>SKU:</b> {{ item.sku }}</div>
        </td>

        <td style="font-size: 12px; color: red" v-else>
          <div><b>TaskID:</b> {{ item._id }}</div>
          <div>
            <b>Product ID:</b>
            <template
              v-if="
                item.product_design_type === 'choose_options' ||
                item.product_design_type === 'upload_photo'
              "
            >
              <a
                :href="
                  '/personalize-products?searchBy=product_id&searchWord=' +
                  item.product_id
                "
                target="_blank"
                style="text-decoration: none"
              >
                {{ item.product_id }}
              </a>
            </template>
            <template
              v-else-if="
                item.product_design_type === 'Crawl Design' ||
                item.product_design_type === 'Personalize Design'
              "
            >
              <a
                :href="
                  '/products?searchBy=product_id&searchWord=' + item.product_id
                "
                target="_blank"
                style="text-decoration: none"
              >
                {{ item.product_id }}
              </a>
            </template>
            <template v-else-if="item.type == 'Normal Design'">
              <a
                :href="
                  '/normal-products?searchBy=product_id&searchWord=' +
                  item.product_id
                "
                target="_blank"
                style="text-decoration: none"
              >
                {{ item.product_id }}
              </a>
            </template>
          </div>
          <div><b>SKU:</b> {{ item.sku }}</div>
        </td>
      </template>
      <template v-slot:item.design_url="{ item }">
        <template v-if="item.design_url != ''">
          <a
            :href="item.design_url"
            target="_blank"
            rel="noopener noreferrer"
            v-if="item.design_url != null"
            >Design URL</a
          >
        </template>
      </template>
      <template v-slot:item.note="{ item }">
        <td style="font-size: 12px">{{ item.note }}</td>
      </template>
      <template v-slot:item.created_date="{ item }">
        <td v-if="!item.urgent && item.priority == 0">
          <div>
            <b>{{ item.createdDateFromNow }}</b>
          </div>
          {{ item.created_date }}
        </td>
        <td v-else style="color: red">
          <div>
            <b>{{ item.createdDateFromNow }}</b>
          </div>
          {{ item.created_date }}
        </td>
      </template>
      <template v-slot:item.last_updated_date="{ item }">
        <td v-if="!item.urgent && item.priority == 0">
          <div>
            <b>{{ item.lastUpdateDateFromNow }}</b>
          </div>
          {{ item.last_updated_date }}
        </td>
        <td v-else style="color: red">
          <div>
            <b>{{ item.lastUpdateDateFromNow }}</b>
          </div>
          {{ item.last_updated_date }}
        </td>
      </template>
      <template v-slot:item.status="{ item }">
        <td>
          <template v-if="item.status == 'Completed'">
            <v-chip class="ma-2" color="success">
              {{ item.status }}
            </v-chip>
          </template>
          <template v-else-if="item.status == 'Canceled'">
            <v-chip class="ma-2" color="red" dark>
              {{ item.status }}
            </v-chip>
          </template>
          <template v-else-if="item.status == 'Need Review'">
            <v-chip class="ma-2" color="#00ACC1" dark>
              {{ item.status }}
            </v-chip>
          </template>
          <template v-else>
            <v-chip class="ma-2" color="orange" dark>
              {{ item.status }}
            </v-chip>
          </template>
        </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          color="primary"
          x-small
          @click="editItem(item._id)"
          v-if="roles.read_task || userId == 'hoaiht'"
        >
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
        <v-btn color="primary" x-small v-else disabled>
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-navigation-drawer v-model="drawer" absolute right temporary>
      <v-list nav dense class="menu-scroll">
        <v-list-item>
          <v-select
            :items="listSearchAll"
            :item-text="(obj) => obj.value"
            :item-value="(obj) => obj.id"
            label="Search All"
            dense
            outlined
            v-model="searchBy"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-text-field
            label="Search here"
            outlined
            v-model="searchWord"
            @keyup.enter="search"
            v-if="searchBy != ''"
            dense
          ></v-text-field>
          <v-text-field
            label="Search here"
            outlined
            v-else
            disabled=""
            dense
          ></v-text-field>
        </v-list-item>

        <v-list-item>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            persistent
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="createdDateRangeText"
                label="Created Date"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="createdDates"
              range
              scrollable
            ></v-date-picker>
            <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
          </v-menu>
        </v-list-item>

        <v-list-item>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            persistent
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="lastUpdateDateRangeText"
                label="Last Update Date"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="lastUpdateDates"
              range
              scrollable
            ></v-date-picker>
            <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
          </v-menu>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listDesigner"
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            label="Designer"
            dense
            outlined
            v-model="filterData.designer_username"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listTaskType"
            label="Task Type"
            dense
            outlined
            v-model="task_type"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-autocomplete
            v-model="sitesSelected"
            :items="listSites"
            :item-text="(obj) => obj.code"
            :item-value="(obj) => obj.code"
            outlined
            dense
            chips
            small-chips
            label="Select Sites"
            multiple
            @input="searchInput = null"
            :search-input.sync="searchInput"
          ></v-autocomplete>
        </v-list-item>

        <v-col cols="12">
          <v-btn
            @click="search"
            small
            outlined
            color="indigo"
            style="float: left"
            >Apply</v-btn
          >
          <v-btn
            @click="reset"
            small
            outlined
            color="indigo"
            style="float: right"
            >Reset</v-btn
          >
        </v-col>
      </v-list>
    </v-navigation-drawer>

    <template>
      <BaseDialog :active.sync="dialogAssign" dialog_name="Assign Designer">
        <AssignDes :listTasks="selected" :listDesigner="listDesigner" />
      </BaseDialog>
    </template>

    <template>
      <BaseDialog :active.sync="dialogExport" dialog_name="Assign Designer">
        <ExportTask :taskSelected="selected" :filterData="filterData" />
      </BaseDialog>
    </template>

    <template>
      <BaseDialog :active.sync="dialogImport" dialog_name="Import Design">
        <ImportTaskDesign />
      </BaseDialog>
    </template>
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment-timezone";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";
import BaseDialog from "../Common/c-base-dialog";
import AssignDes from "./c-dialog-tasks-assigned";
import ExportTask from "./c-dialog-task-export";
import ImportTaskDesign from "./c-dialog-task-import";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "Tags",

  components: {
    BaseDialog,
    AssignDes,
    ExportTask,
    ImportTaskDesign,
  },

  data: () => ({
    imgSrc: "",
    roles: [],

    drawer: false,
    alert: false,
    loading: true,
    dialogAssign: false,
    dialogExport: false,
    dialogNewTask: false,
    dialogImport: false,
    selected: [],
    AuthStr: "", //'Bearer '.concat(this.$cookies.get('token')),
    informText: "",
    listDesigner: [],
    menu2: false,
    menu: false,
    userId: "",

    searchBy: "",
    searchWord: "",
    status: "",
    created_from: "",
    created_to: "",
    last_updated_from: "",
    last_updated_to: "",
    createdDates: [],
    lastUpdateDates: [],
    textDates: "",
    task_type: "",
    sitesSelected: [],
    searchInput: null,

    listTaskType: ["Crawl Design", "Normal Design", "Personalize Design"],

    listSearchAll: [
      { id: "order_number", value: "Order Number" },
      { id: "order_id", value: "Order ID" },
      { id: "task_id", value: "Task ID" },
      { id: "product_id", value: "Product ID" },
    ],

    headers: [
      //{ text: 'TaskID', value: '_id',width: '7%' },
      { text: "Image", value: "thumbnail", align: "start" },
      { text: "Product Info", value: "product_info" },
      {
        text: "Related Orders",
        align: "start",
        value: "related_orders",
        sortable: false,
      },
      { text: "Type", value: "type" },
      { text: "Note", value: "note" },
      { text: "Status", value: "status" },
      { text: "Designer", value: "designer" },
      { text: "Assigner", value: "assigner" },
      { text: "Reviewer", value: "reviewer" },
      { text: "Design URL", value: "design_url" },
      { text: "Create Date", value: "created_date" },
      { text: "Order Time", value: "order_time" },
      { text: "Similar Designs", value: "similar_designs" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    pagination: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      groupBy: false,
      groupDesc: false,
      multiSort: false,
      mustSort: false,
    },

    filterData: {
      searchBy: "",
      searchWord: "",
      designer_username: "",
      createdDates: [],
      status: "",
      siteCodes: "",
    },

    tasks: [],
    listSites: [],
    matchingTasks: 0,
    newTasks: 0,
    totalTasks: 0,
    assignedTasks: 0,
    processingTasks: 0,
    needReviewTasks: 0,
    completedTasks: 0,
    canceledTasks: 0,
  }),

  watch: {
    pagination: {
      handler() {
        let queryParams = this.getParams();
        for (const i of this.tasks) {
          i.showName = false;
          i.showItems = false;
        }

        this.$router
          .push({ path: "tasks", query: queryParams })
          .catch((err) => {
            var error = err.toString();
            if (!error.includes("redundant navigation")) {
              throw err;
            }
          });
        console.log("pagination");
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {
    this.$root.$refs.task = this;
  },

  computed: {
    createdDateRangeText() {
      return this.createdDates.join(" ~ ");
    },
    lastUpdateDateRangeText() {
      return this.lastUpdateDates.join(" ~ ");
    },
  },

  methods: {
    turnOffDialog() {
      this.dialogAssign = false;
      this.dialogExport = false;
      this.dialogNewTask = false;
      this.dialogImport = false;
      this.getDataFromApi();
    },

    clearSelected() {
      this.selected = [];
    },

    showAlert(type, data1, data2) {
      this.alert = true;
      if (type == "import") {
        this.dialogImport = false;
        this.informText =
          "We're currently importing your orders into database. This could take somes minutes to complete. If you'd like, you can close this notification and continue to working.";
      } else if (type == "export") {
        this.dialogExport = false;
        this.informText =
          "We're currently processing your data. System will send a file to your email when completed. If you'd like, you can close this notification and continue to working.";
      } else {
        this.dialogAssign = false;
        this.getDataFromApi();
        this.informText =
          data2.length +
          " selected task(s) have been assigned to '" +
          data1 +
          "'";
        this.selected = [];
      }
    },

    getParams() {
      let queryParams = {
        page: this.pagination.page,
        itemsPerPage: this.pagination.itemsPerPage,
        sortBy: this.pagination.sortBy[0],
        sortDesc: this.pagination.sortDesc[0],
      };

      if (this.searchBy != "" && this.searchWord != "") {
        queryParams["searchBy"] = this.searchBy;
        queryParams["searchWord"] = this.searchWord;
      }

      if (this.status != "") {
        queryParams["status"] = this.status;
      }

      if (this.filterData.designer_username != "") {
        queryParams["designer_username"] = this.filterData.designer_username;
      }

      if (this.createdDates.length > 0) {
        if (this.createdDates[0] > this.createdDates[1]) {
          queryParams["created_from"] = this.createdDates[1];
          queryParams["created_to"] = this.createdDates[0];
        } else {
          queryParams["created_from"] = this.createdDates[0];
          queryParams["created_to"] = this.createdDates[1];
        }
      }

      if (this.sitesSelected.length > 0) {
        this.filterData.siteCodes = this.sitesSelected.join(",");
        queryParams["siteCodes"] = this.filterData.siteCodes;
      }

      if (this.lastUpdateDates.length > 0) {
        if (this.lastUpdateDates[0] > this.lastUpdateDates[1]) {
          queryParams["last_updated_from"] = this.lastUpdateDates[1];
          queryParams["last_updated_to"] = this.lastUpdateDates[0];
        } else {
          queryParams["last_updated_from"] = this.lastUpdateDates[0];
          queryParams["last_updated_to"] = this.lastUpdateDates[1];
        }
      }

      if (this.task_type != "") {
        queryParams["task_type"] = this.task_type;
      }

      return queryParams;
    },

    async getDataFromApi() {
      this.loading = true;

      let queryParams = this.getParams();

      var currentSession = await this.$root.$refs.App.currentSession(
        "task-loadData"
      );
      if (currentSession.accessToken) {
        this.userId = currentSession.username;
        await axios
          .get(window.domain + "tasks", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            console.log(response);
            this.tasks = response.data.data.tasks;
            this.listDesigner = response.data.data.designers;
            this.listSites = response.data.data.sites;
            this.matchingTasks = response.data.data.marchingTasks || 0;
            this.newTasks = response.data.data.newTasks || "0";
            this.totalTasks = response.data.data.totalTasks || "0";
            this.assignedTasks = response.data.data.assignedTasks || "0";
            this.processingTasks = response.data.data.processingTasks || "0";
            this.needReviewTasks = response.data.data.needReviewTasks || "0";
            this.completedTasks = response.data.data.completedTasks || "0";
            this.canceledTasks = response.data.data.canceledTasks || "0";

            var today = moment(new Date()).tz("Asia/Ho_Chi_Minh");

            for (const i of this.tasks) {
              var a = today.diff(
                moment(i.created_date).tz("Asia/Ho_Chi_Minh"),
                "hours"
              );
              i["urgent"] = false;
              i["createdDateFromNow"] = moment(i.created_date).fromNow();
              i["lastUpdateDateFromNow"] = moment(
                i.last_updated_date
              ).fromNow();
              if (i.status != "Completed" && i.status != "Canceled" && a > 72) {
                i["urgent"] = true;
              }
              i["listOrderNumber"] = [];
              i.created_date = moment(i.created_date)
                .tz("Asia/Ho_Chi_Minh")
                .format("DD/MMM/YYYY - HH:mm");
              i.last_updated_date = moment(i.last_updated_date)
                .tz("Asia/Ho_Chi_Minh")
                .format("DD/MMM/YYYY - HH:mm");
              if(i.order_time){
                i.order_time = moment(i.order_time)
                  .tz("Asia/Ho_Chi_Minh")
                  .format("DD/MMM/YYYY - HH:mm");
              }
              for (const j of i.related_orders) {
                i.listOrderNumber.push(j.order_number);
              }
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } else {
        console.log("currentSession task-loadData-undefined: ", currentSession);
      }
    },

    search() {
      let queryParams = this.getParams();
      queryParams.page = 1;
      this.pagination.page = 1;
      //this.selected = []

      (this.filterData = {
        searchBy: this.searchBy,
        searchWord: this.searchWord,
        designer_username: this.filterData.designer_username,
        createdDates: this.createdDates,
        status: this.status,
      }),
        //console.log(queryParams)

        this.$router
          .push({ path: "tasks", query: queryParams })
          .catch((err) => {
            var str = err.toString();
            if (str.includes("current location")) {
              err = "";
            }
          });
      console.log("search");
      this.getDataFromApi();
    },

    reset() {
      //this.$router.push({ path: "tasks" });
      //this.tasks = [];
      this.searchWord = "";
      this.searchBy = "";
      this.status = "";
      this.created_from = "";
      this.created_to = "";
      this.last_updated_to = "";
      this.last_updated_to = "";
      this.lastUpdateDates = [];
      this.createdDates = [];
      this.sitesSelected = [];
      this.task_type = "";
      // (this.pagination = {
      //   page: 1,
      //   itemsPerPage: 10,
      //   sortBy: [],
      //   sortDesc: [],
      //   groupBy: false,
      //   groupDesc: false,
      //   multiSort: false,
      //   mustSort: false,
      // }),
      (this.filterData = {
        searchBy: "",
        searchWord: "",
        createdDates: [],
        status: "",
        designer_username: "",
        siteCodes: "",
      }),
        console.log("search");
      //this.getDataFromApi()
    },

    clear() {
      this.selected = [];
    },

    editItem(item) {
      const params = window.location.search;
      this.$router.push("/tasks-edit/" + item + params);
    },

    check() {
      console.log(this.editedItem);
    },

    validation() {
      if (this.editedItem.tag_name != "") {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },

  async mounted() {
    if (this.$route.query != "") {
      //console.log("true")
      if (this.$route.query.page)
        this.pagination.page = parseInt(this.$route.query.page);
      if (this.$route.query.itemsPerPage)
        this.pagination.itemsPerPage = parseInt(this.$route.query.itemsPerPage);
      if (this.$route.query.sortBy)
        this.pagination.sortBy[0] = this.$route.query.sortBy;
      if (this.$route.query.sortDesc)
        this.pagination.sortDesc[0] = this.$route.query.sortDesc;

      if (this.$route.query.searchBy)
        this.searchBy = this.$route.query.searchBy;
      if (this.$route.query.searchWord)
        this.searchWord = this.$route.query.searchWord;

      if (this.$route.query.status) {
        this.status = this.$route.query.status;
        this.filterData.status = this.status;
      }

      if (this.$route.query.siteCodes) {
        this.filterData.siteCodes = this.$route.query.siteCodes;
        this.sitesSelected = this.filterData.siteCodes.split(",");
      }

      if (this.$route.query.created_from) {
        this.created_from = this.$route.query.created_from;
        this.createdDates.push(this.created_from);
      }
      if (this.$route.query.created_to) {
        this.created_to = this.$route.query.created_to;
        this.createdDates.push(this.created_to);
      }

      if (this.$route.query.last_updated_from) {
        this.last_updated_from = this.$route.query.last_updated_from;
        this.lastUpdateDates.push(this.last_updated_from);
      }
      if (this.$route.query.last_updated_to) {
        this.last_updated_to = this.$route.query.last_updated_to;
        this.lastUpdateDates.push(this.last_updated_to);
      }

      if (this.$route.query.task_type) {
        this.task_type = this.$route.query.task_type;
      }

      if (this.$route.query.designer_username) {
        //console.log(this.$route.query.designer_username)
        this.filterData.designer_username = this.$route.query.designer_username;
      }
    }

    this.roles = await this.$cookies.get("task");
    if (this.roles.list_tasks) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

